export default __webpack_public_path__ + "static/media/Viyankat-Bhawan.099e0666.jpg";